import React from 'react'

const ArrowRight = () => {
  return (
    <path d="M.71.71l9.92 9.92-9.9 9.9" fill="none" stroke="currentColor" strokeWidth="2" />
  )
}

export default ArrowRight
